// extracted by mini-css-extract-plugin
export var cover = "example-module--cover--X1to6";
export var description = "example-module--description--UgwC7";
export var featured = "example-module--featured--rbu7W";
export var img = "example-module--img--GCArf";
export var note = "example-module--note--cqM-W";